/*
 * Application Insights JavaScript SDK - React Plugin, 19.3.8
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ import { useEffect, useRef, useState } from "react";
export default function useCustomEvent(reactPlugin, eventName, eventData, skipFirstRun) {
    if (skipFirstRun === void 0) {
        skipFirstRun = true;
    }
    var _a = useState(eventData), data = _a[0], setData = _a[1];
    var firstRun = useRef(skipFirstRun);
    var savedSkipFirstRun = useRef(skipFirstRun);
    useEffect(function() {
        if (firstRun.current) {
            firstRun.current = false;
            return;
        }
        reactPlugin.trackEvent({
            name: eventName
        }, data);
    }, [
        reactPlugin,
        data,
        eventName
    ]);
    useEffect(function() {
        return function() {
            firstRun.current = savedSkipFirstRun.current;
        };
    }, []);
    return setData;
} //# sourceMappingURL=useTrackEvent.js.map
